export default class Slide {
	public element: Element;
	public isActive = false;
	public isOutgoing = false;

	constructor({element, isActive}: {element: Element, isActive?: boolean}) {
		this.element = element;
		this.isActive = isActive || false;
	}

	/** Set active */
	public activate = () => {
		this.element.classList.remove('outgoing');
		this.element.classList.add('active');
		this.isActive = true;
		this.isOutgoing = false;
	}

	/** Remove active and apply outgoing */
	public deactivate = () => {
		this.element.classList.remove('active');
		this.element.classList.add('outgoing');
		this.isActive = false;
		this.isOutgoing = true;
	}

	/** Remove outgoing */
	public clear = () => {
		this.element.classList.remove('outgoing');
		this.isOutgoing = false;
	}
}
